import { render } from "./OrdersAsSupplierPage.vue?vue&type=template&id=238739a4&ts=true"
import script from "./OrdersAsSupplierPage.ts?vue&type=script&lang=ts"
export * from "./OrdersAsSupplierPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__